export interface FieldsFromBM {
  [indicator: string]: string | null;
}

export const PROFIL_BREITE_CODE = "4";
export const HOHE_LANGE_CODE = "5";
export const VIDEOPOSITION_FIELD = "VIDEOPOSITION";
export const STATION_FIELD = "BM101";
export const MAINCODE_FIELD = "BM105";
export const C1CODE_FIELD = "BM106";
export const C2CODE_FIELD = "BM107";
export const DATUM_FIELD = "BM411";
